const Switch = {
  baseStyle: {
    track: {
      bg: 'gray.300',
      _checked: {
        bg: 'primary',
      },
    },
  },
};

export default Switch;
